// @ts-nocheck
import device from 'current-device'
import useUserStore from '@/store/user'
import { isFunction } from '@/utils/sanitize'
import SparkMD5 from 'spark-md5'
import { getLocalStorage, setLocalStorage } from '@/utils/storage/localstorage'
import dayjs from 'dayjs'

export type OperatingSystem = 'ios' | 'android' | 'macos' | 'windows' | 'others'

// 获取用户操作系统
export const getUserOs = () => {
  let os: OperatingSystem

  if (device.ios()) {
    os = 'ios'
  } else if (device.android()) {
    os = 'android'
    // @ts-ignore 其实是有 macos 这个函数的
  } else if (device.macos()) {
    os = 'macos'
  } else if (device.windows()) {
    os = 'windows'
  } else {
    os = 'others'
  }
  return os
}

// 判断是否为移动端
export const isMobile = () => {
  return device.mobile()
}

// 判断是否为基于 Chromium (Blink 内核) 的浏览器
export const isChromiumBased = () => {
  return navigator.userAgent.includes('Chrome')
}

// 生成唯一识别符(uuid)
export const generateUUID = () => {
  if (!isFunction(crypto.randomUUID)) {
    crypto.randomUUID = function uuidv4() {
      // @ts-ignore
      return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
      );
    }
  }
  return crypto.randomUUID()
}

export const generateRandomString = (length: number) => {
  let result = ''
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  const charactersLength = characters.length
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength))
  }
  return result
}

// 计算客户终端的指纹
export const calcFingerprinting = () => {
  let calcCanvasImageHash = () => {
    let canvas = document.createElement('canvas')
    let ctx = canvas.getContext('2d')
    let text = 'online.hitpaw.com <canvas>'
    if (ctx) {
      ctx.textBaseline = 'top'
      ctx.font = '14px "Arial"'
      ctx.textBaseline = 'alphabetic'
      ctx.fillStyle = '#f60'
      ctx.fillRect(125,1,62,20)
      ctx.fillStyle = '#069'
      ctx.fillText(text, 2, 15)
      ctx.fillStyle = 'rgba(102, 204, 0, 0.7)'
      ctx.fillText(text, 4, 17)
      return getStringMd5(canvas.toDataURL())
    } else {
      return ''
    }
  }
  let calcWebGLReportHash = () => {
    let canvas = document.createElement('canvas')
    let gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl')
    if (gl) {
      let debugInfo = gl.getExtension('WEBGL_debug_renderer_info')
      let vendor = gl.getParameter(debugInfo.UNMASKED_VENDOR_WEBGL);
      let renderer = gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL)
      let str = vendor + '~' + renderer
      return getStringMd5(str)
    } else {
      return ''
    }
  }
  let calcWebGLImageHash = () => {
    let canvas = document.createElement('canvas')
    canvas.width = 256
    canvas.height = 128
    let gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl')

    if (!gl) return ''

    gl.viewport(0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight);
    let program = gl.createProgram()
    let vertexShader = gl.createShader(gl.VERTEX_SHADER)
    gl.shaderSource(vertexShader, 'attribute vec2 attrVertex;attribute vec4 attrColor;varying vec4 varyinColor;uniform mat4 transform;void main(){varyinColor=attrColor;gl_Position=transform*vec4(attrVertex,0,1);}')
    gl.compileShader(vertexShader)
    gl.attachShader(program, vertexShader)
    let fragmentShader = gl.createShader(gl.FRAGMENT_SHADER)
    gl.shaderSource(fragmentShader, 'precision mediump float;varying vec4 varyinColor;void main(){gl_FragColor=varyinColor;}')
    gl.compileShader(fragmentShader)
    gl.attachShader(program, fragmentShader)
    gl.linkProgram(program)
    gl.useProgram(program)
    program.vertexPosAttrib = gl.getAttribLocation(program, 'attrVertex')
    program.colorAttrib = gl.getAttribLocation(program, 'attrColor')
    program.transform = gl.getUniformLocation(program, 'transform')
    gl.enableVertexAttribArray(program.vertexPosAttrib)
    gl.enableVertexAttribArray(program.colorAttrib)
    gl.uniformMatrix4fv(program.transform, !1, [1.5, 0, 0, 0, 0, 1.5, 0, 0, 0, 0, 1, 0, .5, 0, 0, 1])
    let b = [-.25, 0]
    let v = 128
    let x = []
    for (let i = 0; i < v; i++) {
      let S = (45 + i / v * 270) / 360 * 2 * Math.PI
      let C = (45 + (i + 1) / v * 270) / 360 * 2 * Math.PI
      x.push(b[0], b[1], 1, .7, 0, 1)
      x.push(b[0] + .5 * Math.cos(S), b[1] + .5 * Math.sin(S), 2, 1 - i / v, 0, 1)
      x.push(b[0] + .5 * Math.cos(C), b[1] + .5 * Math.sin(C), 1, 1 - (i + 1) / v, 0, 1)
    }
    let R = new Float32Array(x)
    let T = gl.createBuffer()
    gl.bindBuffer(gl.ARRAY_BUFFER, T)
    gl.bufferData(gl.ARRAY_BUFFER, R, gl.STATIC_DRAW)
    gl.vertexAttribPointer(program.vertexPosAttrib, 2, gl.FLOAT, !1, 24, 0)
    gl.vertexAttribPointer(program.colorAttrib, 4, gl.FLOAT, !1, 24, 8)
    gl.drawArrays(gl.LINE_STRIP, 0, R.length / 6)

    return getStringMd5(canvas.toDataURL())
  }
  return calcCanvasImageHash() + calcWebGLReportHash() + calcWebGLImageHash()
}

export const getDeviceDistribution = (deviceId: string) => {
  let arr = Array.from(deviceId)
  let total = 0
  arr.forEach(v => total += parseInt(v, 16))
  return total % 10
}

// 设置初始语言（根据域名）
export const setInitLocale = () => {
  const userStore = useUserStore()
  const hostMap = {
    'ar.hitpaw.com': 'ar',
    'tr.hitpaw.com': 'tr',
    'online.hitpaw.com.br': 'pt',
    'online.hitpaw.de': 'de',
    'online.hitpaw.com': 'en',
    'online.hitpaw.es': 'es',
    'online.hitpaw.fr': 'fr',
    'online.hitpaw.id': 'id',
    'online.hitpaw.in': 'hi',
    'online.hitpaw.it': 'it',
    'online.hitpaw.jp': 'ja',
    'online.hitpaw.kr': 'ko',
    'online.hitpaw.nl': 'nl',
    'online.hitpaw.ru': 'ru',
    'online.hitpaw.tw': 'zh_Hant',
  }

  let matched = hostMap[location.host]
  if (matched) { // 线上环境
    const adaptedLocale = ['en', 'ko', 'pt', 'fr', 'ja', 'zh_Hant', 'ar', 'de', 'it', 'es']
    if (adaptedLocale.includes(matched)) {
      userStore.setLocale(matched)
    } else {
      userStore.setLocale('en')
    }
  }
}

// 转换成旧的区域代码（兼容旧的处理方式）
export const convertToOldLocale = (locale: string) => {
  let localeMap = {
    ar: 'ar',
    pt: 'br',
    de: 'de',
    en: 'en',
    es: 'es',
    fr: 'fr',
    id: 'id',
    hi: 'in',
    it: 'it',
    ja: 'jp',
    ko: 'kr',
    nl: 'nl',
    ru: 'ru',
    tr: 'tr',
    zh_Hant: 'tw'
  }
  return localeMap[locale] || 'en'
}

// 美化 JSON 字符串
export const beautifyJsonString = (str: string) => {
  if (!str) return ''
  try {
    return str.replace(/"([^"]*)":/g, "$1: ").replace(/"/g, "'").replace(/([{])/g, "$1 ").replace(/([}])/g, " $1").replace(/,/g, ", ")
  } catch(e) {
    return ''
  }
}

// 下载桌面端软件
export const downloadDesktopApp = () => {
  const userStore = useUserStore()
  let href = ''
  if (userStore.os === 'macos') {
    href = 'https://download.hitpaw.com/go/hitpaw-video-enhancer-mac-ol_5453.dmg'
  } else {
    href = 'https://download.hitpaw.com/go/hitpaw-video-enhancer-ol_5299.exe'
  }
  window.location.href = href
}

export const getStringMd5 = (str: string) => {
  return SparkMD5.hash(str)
}

/**
 * 均匀抽取指定帧数
 * @param totalFrame - 总帧数
 * @param extractCount - 要抽取的帧数
 */
export const extractFramesUniformly = (totalFrame: number, extractCount: number) => {
  totalFrame = Math.floor(totalFrame)
  const quotient = totalFrame / (extractCount - 1)
  let prev = 1
  let frameList = []

  if (extractCount >= totalFrame) {
    return Array(totalFrame).fill(0).map((v, i) => i + 1)
  }

  for (let i = 0; i < extractCount; i++) {
    let num
    if (i === 0) {
      num = 1
    } else if (i === extractCount) {
      num = totalFrame
    } else {
      num = Math.round(quotient * i)

      if (num <= prev) num += 1
      prev = num
    }

    frameList.push(num)
  }

  return frameList
}

/**
 * 将松散索引重新映射为紧致的连续索引
 * 例如，对于发送到后端的序列 [1, 3, 5, 8, 10, 13, 15, 18]
 * 取回的数据（索引）为 8，则映射为 4（3 + 1）
 * @param initialIndex
 * @param initialArray
 */
export const remapLooseArray = (initialIndex: number, initialArray: number[]) => {
  let index = 0
  for (let i = 0; i < initialArray.length; i++) {
    if (initialIndex === initialArray[i]) {
      index = i + 1
      break
    }
  }

  return index
}

export const getEverydayCount = (key: string) => {
  let dayStr = dayjs().format('YYYY-MM-DD')
  let data = getLocalStorage(key)
  return data && data[dayStr] || 0
}

export const incrEverydayCount = (key: string, clearBefore: boolean = false) => {
  let dayStr = dayjs().format('YYYY-MM-DD')
  let data = getLocalStorage(key)
  if (!data) {
    data = {}
    data[dayStr] = 1
    setLocalStorage(key, data)
  } else {
    let prev = data[dayStr]
    let newData = {}
    if (typeof prev === 'number') {
      newData[dayStr] = prev + 1
    } else {
      newData[dayStr] = 1
    }
    setLocalStorage(key, newData)
  }
}

export const debounce = (fn, timeout = 300) => {
  let timer
  return (...args) => {
    clearTimeout(timer)
    timer = setTimeout(() => { fn.apply(this, args) }, timeout)
  }
}